export const SLUGS = {
  BOOKS_MEDIUM: 'dashboard.slugs.booksMedium',
  BOOKS_FUNDAMENTAL_II: 'dashboard.slugs.booksFundamentalII',
  BOOKS_FUNDAMENTAL_I: 'dashboard.slugs.booksFundamentalI',
  BOOKS_SAEB: 'dashboard.slugs.booksSaeb',
  BOOKS_ENEM: 'dashboard.slugs.booksEnem',
  BOOKS_EJA: 'dashboard.slugs.booksEja',
  COURSES: 'dashboard.slugs.courses',
  SIMULATIONS: 'dashboard.slugs.simulations',
  REDACTION: 'dashboard.slugs.redaction'
};

export const TAB_MENU = [
  {
    title: 'dashboard.tab_menu.redaction',
    slug: SLUGS.REDACTION,
    active: false,
    order: 0
  },
  {
    title: 'dashboard.tab_menu.myCourse',
    slug: SLUGS.COURSES,
    active: false,
    order: 4
  },
  {
    title: 'dashboard.tab_menu.simulated',
    slug: SLUGS.SIMULATIONS,
    active: false,
    order: 5
  }
];

export const TAB_MENU_SALES = [
  // { title: 'Cursos', slug: 'courses', active: true },
  { title: 'Produtos', slug: 'products', active: true }
];
